export default __webpack_public_path__ + "static/Aurora-950099d345bda83c3b824defcb5b4444.png";